import "./playerControls.scss";

import { Player } from "~libs/player";
import { createListComponent, DOMHelper, Listenable, StaticModelSource, View } from "~ui-lib";

import { PlayableItem } from "../rootPage";
import { InfoBanner } from "./infobanner";
import { PlayerButtonList } from "./playerButtons";
import { PlayerProgress } from "./playerProgress";

enum PlayerComponentType {
  progress = "progress",
  buttonList = "buttonList",
}

export interface PlayerControlParams {
  isLive$: Listenable<boolean>;
  uiVisible$: Listenable<boolean>;
  player: Player;
  exitPlayer: () => void;
}

export class PlayerControlList extends View {
  uiVisibleUnregister: () => void;
  private isLiveChange: () => void;
  isLive$: Listenable<boolean>;

  constructor(params: PlayerControlParams, item: PlayableItem) {
    super(DOMHelper.createDivWithParent(null, null, "PlayerControlListContainer"));
    new InfoBanner(this.rootElement, item, params.isLive$.value);

    this.isLive$ = params.isLive$;

    this.delegate = createListComponent({
      rootElement: DOMHelper.createDivWithParent(this.rootElement, "controls", "controls"),
      modelSource: new StaticModelSource([PlayerComponentType.progress, PlayerComponentType.buttonList]),
      viewFactory: model => {
        switch (model) {
          case PlayerComponentType.progress:
            return new PlayerProgress(this.isLive$, params.player);

          case PlayerComponentType.buttonList:
            return new PlayerButtonList(this.isLive$, params.player);
        }
      },
      horizontal: false,
    });
    this.uiVisibleUnregister = params.uiVisible$.didChange(uiVisible => {
      //this.rootElement.hidden = !uiVisible;
      const uiContainer = document.getElementById("uiContainer");
      if (uiContainer) {
        if (uiVisible) {
          DOMHelper.addClass(uiContainer, "visible");
        } else {
          DOMHelper.removeClass(uiContainer, "visible");
        }
      }
    });

    this.isLiveChange = this.isLive$.didChange(isLive => {
      const uiContainer = document.getElementById("uiContainer");
      if (uiContainer) {
        if (isLive) {
          DOMHelper.addClass(uiContainer, "live");
        } else {
          DOMHelper.removeClass(uiContainer, "live");
        }
      }
    });
  }

  onRelease = () => {
    this.uiVisibleUnregister();
    this.isLiveChange();
  };
}
